import { IModel } from '@/@types/models/model';
import coreFields from './helpers/coreFields';

const AppLogs: IModel = {
  title: 'App Logs',
  apiPath: 'system/app_logs',
  forms: {
    default: {
      fields: ['id', 'action_id', 'caller_ip', 'caller_hostname', 'response_status'],
    },
    search: {
      fields: ['id', 'action_id', 'caller_ip', 'caller_hostname', 'response_status'],
    },
  },
  listViews: {
    default: {
      fields: ['id', 'action_id', 'action_tag', 'caller_ip', 'caller_hostname', 'response_status', 'created_on'],
    },
  },
  fields: [
    coreFields.id,
    coreFields.created_on,
    {
      title: 'action_id',
      source: 'action_id',
      ttoken: 'admin:app_logs.action_id',
      type: 'numeric',
      filter: true,
      filterType: 'text',
      readonly: true
    },
    {
      title: 'action_tag',
      source: 'action_tag',
      ttoken: 'admin:app_logs.action_tag',
      type: 'text',
      filter: true,
      readonly: true
    },
    {
      title: 'caller_ip',
      source: 'caller_ip',
      ttoken: 'admin:app_logs.caller_ip',
      type: 'text',
      filter: true,
      readonly: true
    },
    {
      title: 'caller_hostname',
      source: 'caller_hostname',
      ttoken: 'admin:app_logs.caller_hostname',
      type: 'text',
      filter: true,
      readonly: true
    },
    {
      title: 'response_status',
      source: 'response_status',
      ttoken: 'admin:app_logs.response_status',
      type: 'wholenum',
      filter: true,
      readonly: true
    }
  ],
};

export default AppLogs;
